import React from 'react';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useKYC } from 'Hooks/Aggregators/useKYC';
import fr from 'facet-rest';
import { PoweredByRel } from 'Organisms/PoweredByRel';
import { AlertRel } from 'Views/Authentication/Components/AlertRel';
import { dataAttrs } from 'Helpers/Testing';
import isDev from 'Helpers/isDev';

export const IdentityVerificationButton = () => {
  const { resource, handleChange, onSubmit } = useMetaLayoutContext();

  const onKYCFinished = async ({ externalID }) => {
    handleChange('externalId', externalID);
    await onSubmit();
  };

  const {
    startKYC, isInitialized, initializationError, failedToOpen,
  } = useKYC({
    resource,
    onKYCFinished,

  });

  const poweredBy = resource.withRelationship(
    fr.relationships.poweredBy.name,
    (rel) => (<PoweredByRel relationship={rel} />),
    () => null,
  );

  return (
    <FDStack direction={'column'} spacing={1} alignItems={'center'}>
      <FDPrimaryActionButton
        {...dataAttrs('start-identity-verification-btn')}
        disabled={!isInitialized || !!initializationError}
        onClick={startKYC}
        label={'Start identity verification'}
      />
      {poweredBy}
      {failedToOpen ? resource.withRelationship(fr.relationships.plaidErrorSupport.name, (rel) => {
        return (
          <AlertRel
            status={'error'}
            relationship={rel}
            href={rel.link('related').url()}
          />
        );
      }, () => null) : null}
      {isDev() ? (
        <>
          <FDPrimaryActionButton
            {...dataAttrs('submit-success-id-verification-btn')}
            label={'Dev only submit mock success'}
            onClick={() => {
              return onKYCFinished({ externalID: 'success_mfa_reset_external_id' });
            }}
          />
          <FDPrimaryActionButton
            {...dataAttrs('submit-failed-id-verification-btn')}
            label={'Dev only submit mock fail'}
            onClick={() => {
              return onKYCFinished({ externalID: 'failed_external_id' });
            }}
          />
        </>
      ) : null}
    </FDStack>
  );
};
